// Delegation also covers signup links and forms rendered by Turbo navigation.
document.addEventListener("click", (event) => {
  if (event.target.closest?.("a[data-signup-click]")) {
    window.fathom?.trackEvent("Signup clicked")
  }
})

document.addEventListener("submit", (event) => {
  if (event.target.matches?.("form[data-signup-click]")) {
    window.fathom?.trackEvent("Signup clicked")
  }
})
